import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { FaBatteryFull, FaBolt, FaTools, FaCheckCircle, FaCar } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const HybridSpecialist = () => {
  const { t } = useLanguage();

  const hybridServices = [
    { icon: <FaBatteryFull size={32} />, title: t('services.batteryDiag'), description: 'Comprehensive hybrid battery health analysis with industry-leading equipment.' },
    { icon: <FaTools size={32} />, title: t('services.batteryRepair'), description: 'Professional repair of hybrid battery modules and cells to restore performance.' },
    { icon: <FaCar size={32} />, title: t('services.batteryReplace'), description: 'Quality replacement batteries for all major hybrid vehicle brands.' },
    { icon: <FaCheckCircle size={32} />, title: t('services.systemInspection'), description: 'Complete hybrid system inspection covering all electrical components.' },
    { icon: <FaBolt size={32} />, title: t('services.hvTesting'), description: 'High voltage system testing with certified safety protocols.' }
  ];

  const supportedBrands = [
    'Toyota Hybrid', 'Lexus Hybrid', 'Honda Hybrid', 'BMW Hybrid', 'Mercedes-Benz Hybrid', 'Audi Hybrid'
  ];

  return (
    <div className="min-h-screen" data-testid="hybrid-page">
      <section className="relative h-[500px] flex items-center bg-cover bg-center"
        style={{ backgroundImage: 'url(https://customer-assets.emergentagent.com/job_premium-workshop-1/artifacts/8uizlpnp_New%202.jpeg)' }}
      >
        <div className="absolute inset-0 bg-dark-navy/85"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-blue-400/20 mb-6">
            <FaBatteryFull className="text-blue-400" size={40} />
          </div>
          <h1 className="font-cabinet font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white mb-4">
            HYBRID VEHICLE SPECIALIST
          </h1>
          <p className="text-lg text-gray-200 max-w-2xl mx-auto">
            Expert hybrid battery diagnosis, repair & replacement services
          </p>
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="font-cabinet font-bold text-3xl text-dark-navy mb-4">
              Complete Hybrid Vehicle Services
            </h2>
            <p className="text-gray-600 text-base max-w-2xl mx-auto">
              We are Muar's leading specialist for hybrid vehicle diagnostics, battery repair, and complete hybrid system maintenance.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {hybridServices.map((service, index) => (
              <div 
                key={index}
                data-testid={`hybrid-service-${index}`}
                className="bg-light-grey p-8 border border-gray-200 hover:shadow-md hover:border-royal-blue transition-all"
              >
                <div className="text-royal-blue mb-4">
                  {service.icon}
                </div>
                <h3 className="font-cabinet font-bold text-xl text-dark-navy mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {service.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-light-grey">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="font-cabinet font-bold text-3xl text-dark-navy mb-4">
              Supported Hybrid Brands
            </h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
            {supportedBrands.map((brand, index) => (
              <div key={index} className="flex flex-col items-center bg-white p-6 border border-gray-200">
                <FaCar className="text-royal-blue mb-3" size={32} />
                <span className="font-cabinet font-semibold text-sm text-dark-navy text-center">{brand}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-royal-blue text-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="font-cabinet font-bold text-3xl mb-4">Need Hybrid Vehicle Service?</h2>
          <p className="text-base mb-8 text-gray-200">Get expert diagnosis and repair from Muar's hybrid specialists</p>
          <Link 
            to="/contact"
            data-testid="hybrid-cta-contact"
            className="inline-block px-8 py-3 bg-white text-royal-blue font-cabinet font-bold hover:bg-gray-100 transition-colors uppercase tracking-wide"
          >
            Book Appointment
          </Link>
        </div>
      </section>
    </div>
  );
};

export default HybridSpecialist;
